/**
 * This mixin exposes the isDirty data properties, which when set to true prevents the browser tab
 * to be closed or navigated away from. Implementation of the isDirty is the responsibility of the
 * component that uses this mixin.
 */
export default {
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    beforeWindowUnload(e) {
      if (this.isDirty) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
  },
}
